<template>
  <div
    v-loading="loading"
    class="order-box"
  >
    <template v-if="goodsData.list.length">
      <ul class="head-order">
        <li><span>{{ lang.title_row1 }}</span></li>
        <li><span>{{ lang.title_row2 }}</span></li>
        <li><span>{{ lang.title_row3 }}</span></li>
        <li><span>{{ lang.title_row4 }}</span></li>
        <li><span>{{ lang.title_row5 }}</span></li>
        <li><span>{{ lang.title_row6 }}</span></li>
        <li><span>{{ lang.title_row7 }}</span></li>
      </ul>
      <div class="order-list">
        <div
          v-for="(item, index) in goodsData.list"
          :key="index"
          class="item-order"
        >
          <div class="item-head">
            <div class="left">
              <span>{{ item.addtime }}</span>
              <span>{{ lang.orderno }}：{{ item.orderno }}</span>
              <span v-if="item.orderptype === 4 && item.pickupCode">{{ lang.self_code }}：{{ item.pickupCode }}</span>
            </div>
          </div>
          <div class="self-mention" >
            <el-image :src="item.vedinfo.vemimg" fit="cover" lazy  />
            <div class="cont" @click="$router.push(item.vedinfo.ptype === 1 ? `/machine/index?vemId=${item.vedinfo.vemId}` : `/coffee/index?vemId=${item.vedinfo.vemId}`)">
              <div class="name">{{ item.vedinfo.vemName }}</div>
              <div class="vemid">{{ lang.vemid }}：{{ item.vedinfo.vemId }}</div>
            </div>
            <div class="right">
              <div class="address">{{ item.vedinfo.vemaddress }}</div>
              <div class="distance"><svg-icon iconClass="location" />{{ lang.distance }}：{{ item.vedinfo.distance }}{{ item.vedinfo.distanceunit }}</div>
            </div>
          </div>
          <div class="content">
            <ul class="goods-cont">
              <li
                v-for="(v, k) in item.orderitem"
                :key="k"
              >
                <el-image
                  :src="v.productimg"
                  lazy
                  @click.stop="$router.push('/goods/info/'+v.productno)"
                ></el-image>
                <div class="goods-info">
                  <div class="item-title">{{ v.productname }}</div>
                  <div class="item-desc">{{ v.briefName }}</div>
                </div>
                <div class="goods-price">
                  <div
                    v-if="v.productpricedoor > 0"
                    class="o-price"
                  >{{ lang.original_price }}：MOP {{ v.productpricedoor.toFixed(2) }}</div>
                  <div
                    v-if="v.integral > 0"
                    class="d-price"
                  >MOP&nbsp;{{ v.productprice.toFixed(2) }} + {{ v.integral }}{{ lang.point }}</div>
                  <div
                    v-else
                    class="d-price"
                  >MOP&nbsp;{{ v.productprice.toFixed(2) }}</div>
                </div>
                <div class="goods-num">{{ v.productnum }}</div>
                <div class="goods-action">
                  <!-- <div class="btn">退款<i class="el-icon-arrow-right"></i></div> -->
                  <div
                    v-if="v.refundstatus === -1 && item.orderptype === 3 && item.states === 1 || v.refundstatus === -1 && item.orderptype === 3 && item.states === 2"
                    class="right"
                    @click="getGoodsCode(v.id)"
                  >{{ lang.redemption_code }}<i class="el-icon-arrow-right"></i></div>
                  <div class="code-endtime">
                    <span v-if="v.refundstatus > 0">{{ v.refundstatustext }}</span>
                    <span v-if="v.deliverStatustime">{{ lang.has_been }}{{ v.deliverStatustime }}{{ lang.exchange }}</span>
                  </div>
                </div>
              </li>
            </ul>
            <div class="goods-amount">
              <div v-if="item.hdtype === 1" class="item-price">{{ lang.point }}&nbsp;{{ item.paypoint }}</div>
              <div v-else class="item-price">
                <template v-if="item.paypoint > 0">
                  MOP&nbsp;{{ item.totalpaymoney.toFixed(2) }} + {{ item.paypoint }}{{ lang.point }}
                </template>
                <template v-else>
                  MOP&nbsp;{{ item.totalpaymoney.toFixed(2) }}
                </template>
              </div>
            </div>
            <div class="goods-status">
              <div class="item-status">{{ item.statestext }}</div>
              <div
                class="item-text"
                @click="$router.push(`/order/detail?orderno=${item.orderno}`)"
              >{{ lang.order_detail }}</div>
            </div>
            <div class="right">
              <div
                v-if="item.states === 0"
                class="btn"
                @click="handlePay(item.orderno)"
              >{{ lang.settle }}</div>
              <!-- <div
                v-if="item.states >= 1 && item.states <= 2"
                class="btn"
                @click="handleRefund(item.orderno)"
              >申请退款</div> -->
              <div
                v-if="item.states === 0"
                class="btn-text"
                @click="handleCancel(item.orderno)"
              >{{ lang.cancel_order }}</div>
              <div
                v-if="item.states >= 3"
                class="btn-text"
                @click="handleDel(item.orderno)"
              >{{ lang.delete_order }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_fy_block">
        <el-pagination
          @current-change="changePage"
          background
          layout="prev, pager, next,jumper,total"
          :total="goodsData.total"
          :page-size="params.pageSize"
          :current-page="params.pageNum"
        ></el-pagination>
      </div>
    </template>
    <!-- 没有订单 -->
    <template v-else>
      <div
        v-if="params.states === -1"
        class="empty_order"
      >
        <dl>
          <dt><img src="/images/not-common-icon.png"></dt>
          <dd>{{ lang.empty_tips }}</dd>
          <dd class="btn">
            <router-link to="/">{{ lang.empty_btn }}</router-link>
          </dd>
        </dl>
      </div>
      <el-empty
        v-else
        :description="lang.no_related_orders"
      ></el-empty>
    </template>
    <!-- 兑换码 -->
    <el-dialog
      :visible.sync="codeData.show"
      width="280px"
      class="code-box"
    >
      <div v-loading="codeData.loading">
        <div class="tip">{{ lang.code_text1 }}</div>
        <div class="tip">{{ lang.code_text2 }}</div>
        <div class="title">{{ lang.code_text3 }}</div>
        <div class="num">{{ codeData.code }}</div>
      </div>
    </el-dialog>
    <el-dialog
      class="pay-dialog"
      :visible.sync="showPayDialog"
      :close-on-click-modal="false"
      width="30%"
    >
      <i class="el-icon-loading" />
      <div class="loading-text">{{ lang.payments }}</div>
      <div class="btn" @click="$router.push(`/order/detail?orderno=${currentOrder}`)">{{ lang.view_order_detail }}</div>
    </el-dialog>
    <!-- 支付选择弹窗 -->
    <PayDialog ref="payDialog"></PayDialog>
  </div>
</template>

<script>
import {
  getorderlist,
  cancelpayorder,
  refundpayorder,
  delorder,
  getorderitemcode
} from '@/api/orderuser';
import PayDialog from '@/components/PayDialog/index.vue';
import { getqueryorderstate } from '@/api/orderuser.js';
export default {
  components: {
    PayDialog
  },
  computed: {
    lang() {
      return this.$t('user_order');
    }
  },
  data() {
    return {
      params: {
        states: -1, // 订单状态 0待付款 1待发货/待自提 2配送中 3已完成 4已取消 5退款/售后
        pageNum: 1,
        pageSize: 6
      },
      loading: false,
      goodsData: {
        list: [],
        total: 0
      },
      codeData: {
        loading: false,
        show: false,
        code: ''
      },
      timer: '',
      showPayDialog: false,
      currentOrder: ''
    };
  },
  created() {
    this.getQueryType(this.$route.query.type);
    this.getList();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.fullPath != from.fullPath) {
      this.getQueryType(to.query.type);
      this.getList();
    }
    next();
  },
  methods: {
    // 获取兑换码
    getGoodsCode(orderitemid) {
      this.codeData.loading = true;
      getorderitemcode({ orderitemid }).then(({ data }) => {
        this.codeData.loading = false;
        if (data) {
          this.codeData.show = true;
          this.codeData.code = data.pickupCode;
        }
      });
    },
    getQueryType(val) {
      let type = parseFloat(val);
      switch (type) {
        case 1:
          this.params.states = 0;
          break;
        case 2:
          this.params.states = 1;
          break;
        case 3:
          this.params.states = 2;
          break;
        case 4:
          this.params.states = 4;
          break;
        case 5:
          this.params.states = 3;
          break;
        default:
          this.params.states = -1;
          break;
      }
    },
    async getList() {
      this.loading = true;
      const { data } = await getorderlist(this.params);
      this.goodsData.list = data.data;
      this.goodsData.total = data.count;
      this.loading = false;
    },
    changePage(val) {
      this.params.pageNum = val;
      this.getList();
    },
    handleCancel(orderno) {
      this.$confirm(this.lang.cancel_tips, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        cancelpayorder({ orderno: orderno }).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg);
            this.getList();
          }
        });
      });
    },
    handleDel(orderno) {
      this.$confirm(this.lang.delete_tips, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        delorder({ orderno: orderno }).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg);
            this.getList();
          }
        });
      });
    },
    handleRefund(orderno) {
      this.$confirm(this.lang.refund_tips, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        refundpayorder({ orderno: orderno }).then((res) => {
          if (res.code === 1) {
            this.$message.success(res.msg);
            this.getList();
          }
        });
      });
    },
    async handlePay(orderno) {
      this.$refs.payDialog.showDialog(orderno)
    },
    getPayState(orderno) {
      getqueryorderstate({
        orderno: orderno
      }).then(({ data }) => {
        if (data.ispay === 1) {
          clearInterval(this.timer)
          this.$router.push(`/order/detail?orderno=${orderno}`)
        }
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>

<style lang="scss" scoped>
.head-order {
  display: flex;
  align-items: center;
  height: 36px;
  line-height: 36px;
  background: #ffffff;
  border: 1px solid rgba(236, 146, 33, 0.3);
  padding: 0 15px;
  li {
    text-align: center;
    span {
      color: #000;
      font-size: 12px;
    }
    width: 239px;
    &:nth-child(2) {
      width: 133px;
    }
    &:nth-child(3) {
      width: 80px;
    }
    &:nth-child(4) {
      width: 100px;
    }
    &:nth-child(5) {
      width: 160px;
    }
    &:nth-child(6) {
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 120px;
      i {
        margin-left: 2px;
        font-size: 16px;
      }
    }
    &:nth-child(7) {
      width: 103px;
    }
  }
}
.head-action {
  display: flex;
  align-items: center;
  height: 44px;
  .all-select {
    margin-right: 30px;
    .el-checkbox {
      color: #000;
      font-size: 12px;
    }
    .el-checkbox__input {
      line-height: inherit;
    }
  }
  .btn {
    text-align: center;
    width: 92px;
    height: 24px;
    line-height: 24px;
    background: #ffffff;
    border: 1px solid #aaaaaa;
    color: #000;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      background: #fadfbd;
    }
  }
}
.order-list {
  padding-top: 20px;
  .item-order {
    border: 1px solid rgba(236, 146, 33, 0.3);
    margin-bottom: 20px;
    .item-head {
      display: flex;
      align-content: center;
      background: #fadfbd;
      line-height: 44px;
      padding: 0 15px;
      font-size: 12px;
      color: #000;
      font-size: 500;
      span {
        padding-right: 20px;
      }
      .el-checkbox__input {
        line-height: inherit;
      }
      .item-name {
        flex: 1;
        font-size: 12px;
        color: #000;
        padding-left: 100px;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      padding: 15px 0 15px 15px;
      background: #ffffff;
      text-align: center;
      font-size: 12px;
      .goods-cont {
        li {
          display: flex;
          margin-bottom: 15px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .el-image {
        width: 104px;
        height: 84px;
        margin-right: 15px;
        cursor: pointer;
      }
      .goods-info,
      .goods-status,
      .goods-action,
      .right {
        width: 104px;
        margin-right: 15px;
      }
      .code-endtime {
        color: #ff0000;
        font-size: 12px;
        padding-top: 4px;
      }
      .goods-info {
        text-align: left;
        cursor: pointer;
        .item-title {
          color: #000000;
          margin-bottom: 6px;
        }
        .item-desc {
          color: #aaaaaa;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }
      }
      .goods-action {
        .btn {
          color: #000000;
          cursor: pointer;
          margin-bottom: 5px;
          &:hover {
            color: #ec9221;
          }
        }
        .right {
          cursor: pointer;
          &:hover {
            color: #ec9221;
          }
        }
      }
      .goods-price {
        width: 133px;
        margin-right: 15px;
        .o-price {
          color: #4f4f4f;
          text-decoration: line-through;
          margin-bottom: 6px;
        }
        .d-price {
          color: #000;
        }
      }
      .goods-num {
        width: 50px;
        margin-right: 15px;
        color: #4f4f4f;
      }
      .goods-amount {
        width: 128px;
        margin-right: 15px;
        .item-text {
          color: #4f4f4f;
        }
        .item-price {
          color: #000;
          margin-bottom: 6px;
        }
      }
      .goods-status {
        div {
          padding-bottom: 6px;
        }
        .item-status {
          color: #000000;
        }
        .item-text {
          color: #4f4f4f;
          cursor: pointer;
          &:hover {
            color: #ec9221;
          }
        }
        .item-action {
          color: #ff0000;
        }
      }
      .right {
        .btn {
          cursor: pointer;
          margin: 0 auto 6px;
          text-align: center;
          width: 68px;
          height: 24px;
          line-height: 24px;
          background: #ec9221;
          border-radius: 4px;
          font-size: 12px;
          color: #ffffff;
        }
        .btn-text {
          font-size: 12px;
          cursor: pointer;
          color: #4f4f4f;
        }
      }
    }
  }
}
.home_fy_block {
  padding: 24px 0 0;
}
.order-box {
  min-height: 712px;
}
/deep/ .code-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-dialog__header {
    padding: 0 !important;
  }
  text-align: center;
  .tip {
    color: #ff0000;
    font-size: 15px;
  }
  .title {
    color: #000000;
    font-size: 20px;
    padding: 20px 0 10px;
  }
  .num {
    font-weight: bold;
    color: #000000;
    font-size: 20px;
    letter-spacing: 6px;
  }
}
.pay-dialog {
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    display: none;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  i {
    font-size: 60px;
    font-weight: bold;
    color: #ec9221;
  }
  .loading-text {
    color: #aaa;
    font-size: 14px;
    padding: 10px 0 20px;
  }
  .btn {
    cursor: pointer;
    width: 120px;
    height: 38px;
    line-height: 38px;
    margin: 0 auto;
    background: #ec9221;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
  }
}
.self-mention {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background: #fff;
  .el-image {
    width: 68px;
    height: 40px;
    border-radius: 4px;
  }
  .cont {
    cursor: pointer;
    flex: 1;
    margin-left: 15px;
    .name {
      color: #000;
      font-size: 14px;
    }
    .vemid {
      color: #999;
      font-size: 12px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    .address, .distance {
      display: flex;
      align-items: center;
      color: #000;
      font-size: 14px;
      margin-left: 30px;
      .svg-icon {
        width: 16px;
        margin-right: 8rpx;
      }
    }
  }
}
</style>